import { useParams } from "react-router-dom";

export const useLanguage = () => {
  const { language } = useParams();
  return language;
};
